import React from 'react';
import { useRelayEnvironment } from 'react-relay';

import { getColorStatus, getObjectFromRelayStoreById } from '../functions';
import { ListItemType, TaskPositionType } from '../types';

interface ICalendarTaskBodyBage {
    task: TaskPositionType;
    widthTaskBody: number;
}

const CalendarTaskBodyBadge: React.FC<ICalendarTaskBodyBage> = ({ task }) => {
    const environment = useRelayEnvironment();

    const statusTask = task.status
        ? (getObjectFromRelayStoreById(environment, task.status?.toString()) as ListItemType)
        : undefined;

    return (
        <>
            {statusTask && (
                <label
                    style={{
                        backgroundColor: getColorStatus(task?.status),
                        border: '1px solid white',
                        borderRadius: '20px',
                        padding: '0px 10px',
                        zIndex: 1000,
                        fontSize: 10,
                        height: 16,
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: 'white',
                    }}
                >
                    <span style={{ color: 'white' }}>{statusTask.name}</span>
                </label>
            )}
        </>
    );
};

export default CalendarTaskBodyBadge;
